import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEnvelope = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.3335 23.3334V4.66675H25.6668V23.3334H2.3335ZM14.0002 14.739L4.27792 8.45839V21.389H23.7224V8.45839L14.0002 14.739ZM14.0002 12.7945L23.6446 6.61117H4.37516L14.0002 12.7945ZM4.27792 8.45839V6.61117V21.389V8.45839Z",
		fill: "currentColor"
	})
});
export default SvgEnvelope;
